import {
  ADD_LEAVE_OF_USERS_FAIL,
  ADD_LEAVE_OF_USERS_REQUEST,
  ADD_LEAVE_OF_USERS_SUCCESS,
  DELETE_LEAVE_OF_USERS_FAIL,
  DELETE_LEAVE_OF_USERS_REQUEST,
  DELETE_LEAVE_OF_USERS_SUCCESS,
  GET_LEAVE_OF_USERS_BY_ID_FAIL,
  GET_LEAVE_OF_USERS_BY_ID_REQUEST,
  GET_LEAVE_OF_USERS_BY_ID_SUCCESS,
  GET_LEAVE_SETTING_FAIL,
  GET_LEAVE_SETTING_REQUEST,
  GET_LEAVE_SETTING_SUCCESS,
  GET_LEAVE_OF_COMPANY_FAIL,
  GET_LEAVE_OF_COMPANY_REQUEST,
  GET_LEAVE_OF_COMPANY_SUCCESS,
  ADD_LEAVE_OF_USERS_REJECT_FAIL,
  ADD_LEAVE_OF_USERS_REJECT_REQUEST,
  ADD_LEAVE_OF_USERS_REJECT_SUCCESS,
  ADD_LEAVE_OF_USERS_APPROVE_FAIL,
  ADD_LEAVE_OF_USERS_APPROVE_REQUEST,
  ADD_LEAVE_OF_USERS_APPROVE_SUCCESS,
} from "../../types/user/leaveManagmentType";

export const addLeaveInUserReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case ADD_LEAVE_OF_USERS_REQUEST:
      return {
        ...state,
        addLeaveLoading: true,
      };
    case ADD_LEAVE_OF_USERS_SUCCESS:
      return {
        ...state,
        addLeaveLoading: false,
        addLeaveInfo: payload,
        addLeaveErrors: "",
      };
    case ADD_LEAVE_OF_USERS_FAIL:
      return {
        ...state,
        addLeaveLoading: false,
        addLeaveErrors: payload,
        addLeaveInfo: [],
      };
    default:
      return state;
  }
};

export const getLeaveInUserReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_LEAVE_OF_USERS_BY_ID_REQUEST:
      return {
        ...state,
        getLeaveByCompLoadings: true,
      };
    case GET_LEAVE_OF_USERS_BY_ID_SUCCESS:
      return {
        ...state,
        getLeaveByCompLoadings: false,
        getLeaveByCompInfo: payload,
        getLeaveByCompErrors: "",
      };
    case GET_LEAVE_OF_USERS_BY_ID_FAIL:
      return {
        ...state,
        getLeaveByCompLoadings: false,
        getLeaveByCompErrors: payload,
        getLeaveByCompInfo: [],
      };
    default:
      return state;
  }
};

export const getLeaveByCompanyInManagerReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_LEAVE_OF_COMPANY_REQUEST:
      return {
        ...state,
        getLeaveCompLoadings: true,
      };
    case GET_LEAVE_OF_COMPANY_SUCCESS:
      return {
        ...state,
        getLeaveCompLoadings: false,
        getLeaveCompInfo: payload,
        getLeaveCompErrors: "",
      };
    case GET_LEAVE_OF_COMPANY_FAIL:
      return {
        ...state,
        getLeaveCompLoadings: false,
        getLeaveCompErrors: payload,
        getLeaveCompInfo: [],
      };
    default:
      return state;
  }
};

export const deleteLeaveInUserReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case DELETE_LEAVE_OF_USERS_REQUEST:
      return {
        ...state,
        deleteLeaveLoadings: true,
      };
    case DELETE_LEAVE_OF_USERS_SUCCESS:
      return {
        ...state,
        deleteLeaveLoadings: false,
        deleteLeaveInfo: payload,
        deleteLeaveErrors: "",
      };
    case DELETE_LEAVE_OF_USERS_FAIL:
      return {
        ...state,
        deleteLeaveLoadings: false,
        deleteLeaveErrors: payload,
        deleteLeaveInfo: [],
      };
    default:
      return state;
  }
};

export const getLeaveSettingReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_LEAVE_SETTING_REQUEST:
      return {
        ...state,
        LeaveSettLoadings: true,
      };
    case GET_LEAVE_SETTING_SUCCESS:
      return {
        ...state,
        LeaveSettLoadings: false,
        LeaveSettInfo: payload,
        LeaveSettErrors: "",
      };
    case GET_LEAVE_SETTING_FAIL:
      return {
        ...state,
        LeaveSettLoadings: false,
        LeaveSettErrors: payload,
        LeaveSettInfo: [],
      };
    default:
      return state;
  }
};

export const addApproveLeaveByManagerReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case ADD_LEAVE_OF_USERS_APPROVE_REQUEST:
      return {
        ...state,
        approveLeaveLoadings: true,
      };
    case ADD_LEAVE_OF_USERS_APPROVE_SUCCESS:
      return {
        ...state,
        approveLeavelLoadings: false,
        approveLeavelInfo: payload,
        approveLeavelErrors: "",
      };
    case ADD_LEAVE_OF_USERS_APPROVE_FAIL:
      return {
        ...state,
        approveLeavelLoadings: false,
        approveLeavelErrors: payload,
        approveLeavelInfo: [],
      };
    default:
      return state;
  }
};

export const addRejectLeaveByManagerReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case ADD_LEAVE_OF_USERS_REJECT_REQUEST:
      return {
        ...state,
        rejectLeaveLoadings: true,
      };
    case ADD_LEAVE_OF_USERS_REJECT_SUCCESS:
      return {
        ...state,
        rejectLeavelLoadings: false,
        rejectLeavelInfo: payload,
        rejectLeavelErrors: "",
      };
    case ADD_LEAVE_OF_USERS_REJECT_FAIL:
      return {
        ...state,
        rejectLeavelLoadings: false,
        rejectLeavelErrors: payload,
        rejectLeavelInfo: [],
      };
    default:
      return state;
  }
};
